import { Box } from '@mui/material'

export const MissingAuth = () => {
  return (
    <Box display="flex" height="100vh" width="100vw" justifyContent="center" alignItems="center">
      Missing auth or tenant id
    </Box>
  )
}
